import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import NavbarData from '../data/navbar';
import Logo from '../assets/img/Logo/Logos.png';

const Navbar = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate(); // Initialize navigate function

  const handleNavClick = (index) => {
    setActiveIndex(index);
    setIsMobileMenuOpen(false);
  };

  const handleGetInvolvedClick = () => {
    navigate('/getinvolved'); // Navigate to '/getinvolved' when the button is clicked
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 text-[1.05rem]">
      {/* Top Contact Bar - Desktop Only */}
      <div className="hidden lg:flex justify-center items-center bg-black bg-opacity-80 py-2 px-4 text-sm text-white space-x-16">
        <div className="flex items-center space-x-2 text-[#90444D]">
          <i className="fa-solid fa-location-dot"></i>
          <p className='text-white'>Megenagna Addis Ababa, Ethiopia</p>
        </div>
        <div className="flex items-center space-x-2 text-[#90444D]">
          <i className="fa-solid fa-phone"></i>
          <p className='text-white'>+251 116 66 28 80 | +251 911 25 74 03</p>
        </div>
        <div className="flex items-center space-x-2 text-[#90444D]">
          <i className="fa-solid fa-envelope"></i>
          <p className='text-white'>cccea@ccfcea.org</p>
        </div>
        <div className="flex items-center space-x-2 text-[#90444D]">
          <i className="fa-solid fa-envelopes-bulk"></i>
          <p className='text-white'>21154</p>
        </div>
      </div>

      {/* Main Nav */}
      <div className="bg-white bg-opacity-80 shadow-sm backdrop-blur-md">
        <div className="max-w-8xl mx-auto px-6 sm:px-6 lg:px-16 flex justify-between items-center py-3">
          {/* Logo */}
          <div className="">
            <img
              src={Logo}
              alt="Logo"
              className="h-10 md:w-auto w-[250px]"
            />
          </div>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex space-x-16 items-center">
            {NavbarData.map((item, index) => (
              <li key={item.path} onClick={() => handleNavClick(index)}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `py-2 transition duration-200 border-b-2 ${
                      activeIndex === index || isActive
                        ? 'font-semibold text-white bg-customGreen rounded-full p-6'
                        : 'font-light text-customGreen border-transparent hover:text-cyan-800'
                    }`
                  }
                >
                  {item.title}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="hidden lg:block">
            <button
              className="px-4 py-2 bg-customGreen text-white rounded hover:bg-cyan-800 transition duration-200"
              onClick={handleGetInvolvedClick} // Use handleGetInvolvedClick
            >
              Get Involved
            </button>
          </div>

          {/* Mobile Hamburger */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 focus:outline-none"
            >
              <svg
                className="w-7 h-7"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white bg-opacity-90 backdrop-blur-md px-4 py-4 space-y-4 transition-all duration-300 ease-in-out shadow-md">
            <ul className="flex flex-col space-y-2">
              {NavbarData.map((item, index) => (
                <li key={item.path} onClick={() => handleNavClick(index)}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `block py-2 px-2 transition duration-150 hover:text-cyan-800 ${
                        activeIndex === index || isActive
                          ? 'font-medium border-b-2 border-cyan-950'
                          : 'font-light text-gray-700'
                      }`
                    }
                  >
                    {item.title}
                  </NavLink>
                </li>
              ))}
            </ul>
            <button
              className="w-full px-4 py-2 bg-customGreen text-white rounded hover:bg-cyan-800 transition duration-200 mt-4"
              onClick={handleGetInvolvedClick} // Use handleGetInvolvedClick
            >
              Get Involved
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
